<template>
    <div>
        <Header>

            <div class="buttons-right">
                <save-button name="Settings" :status="saving" @save="save()"></save-button>
            </div>

        </Header>

        <div class="page">
            <div class="block" v-if="subscriberSettings">
                <h3 class="block__heading" v-t="'Subscriber Settings'"></h3>
                <p v-t="'people.newsletter-desc'"></p>
                <field :errors="errors" class="field field-switch">
                    <label class="switch">
                        <input v-model="subscriberSettings.subscription_signup_enabled" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label" v-t="'Show subscription option on portfolio'"></span>
                </field>
                <field :errors="errors" class="field field-switch">
                    <label class="switch">
                        <input v-model="subscriberSettings.subscription_email_enabled" type="checkbox">
                        <div class="slider round"></div>
                    </label>
                    <span class="label" v-t="'Enable weekly email to subscribers if there are new articles'"></span>
                </field>

                <span v-if="subscriberSettings.mailchimp_connected">
                    <div class="hr"></div>

                    <field :errors="errors" class="field" label="Mailchimp Audience to import to" >
                        <select v-model="subscriberSettings.mailchimp_list_id">
                            <option :value="null" v-t="'people.mailchimp-select-audience'"></option>
                            <option v-for="audience in mailchimpAudiences" v-bind:key="audience.name" :value="audience.id">{{audience.name}}</option>
                        </select>
                    </field>

                    <p style="margin-bottom: 0"><a @click="disconnectMailchimp()" v-t="'people.mailchimp-disconnect'"></a></p>
                </span>

                <span v-if="!subscriberSettings.mailchimp_connected">
                    <button @click="mailchimpModalOpen=true" class="button--mailchimp"><img :src="VUE_APP_STATIC_URL + 'img/mailchimp.png'"> <span v-t="'people.mailchimp-connect'"></span></button>
                </span>
            </div>
            <table class="editor-table">
                <thead>
                    <tr>
                        <th v-t="'Subscriber Name'"></th>
                        <th v-t="'Date Subscribed'"></th>
                        <th v-t="'Date Unsubscribed'"></th>
                        <th v-t="'Status'"></th>
                    </tr>
                </thead>
                <tbody v-if="!subscribers">
                    <tr>
                        <td colspan="100%">
                            <div class="loading-gif" >
                                <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="subscribers">
                    <tr v-bind:key="subscriber.id" v-for="subscriber in subscribers">
                        <td>
                            <h3>{{subscriber.name}}</h3>
                            <span class="ellipsis grey">
                            {{subscriber.email}}</span>
                        </td>
                        <td>
                            {{subscriber.created | date}}
                        </td>
                        <td>
                            <span v-if="subscriber.unsubscribed_at">{{subscriber.unsubscribed_at | date}}</span>
                            <span v-if="!subscriber.unsubscribed_at">-</span>
                        </td>
                        <td>
                            <span v-if="subscriber.status=='unsubscribed'" v-t="'Unsubscribed'"></span>
                            <span v-if="subscriber.status=='active'" v-t="'Subscribed'"></span>
                        </td>
                    </tr>
                    <tr v-if="subscribers.length==0">
                        <td colspan="100%" v-t="'No Subscribers yet.'">

                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="subscribers">
                    <td colspan="100%">
                        {{subscribers.length}} <span v-t="'Subscribers'"></span>
                    </td>
                </tfoot>
            </table>
        </div>

        <modal :open="mailchimpModalOpen" title="Connect with Mailchimp" @close="mailchimpModalOpen=false">

            <p>
                <strong>How it works:</strong> existing subscribers and new subscribers will be imported into a Mailchimp audience that you specify.
            </p>

            <p>
                <strong>How to connect:</strong> after clicking connect below you will be redirected to Mailchimp to login and authorise the connection. You will then be redirected back here to choose the Audience to import to. If you don't have one already you will need to create an Audience on Mailchimp.
            </p>

            <div class="modal__done">
                <button @click="mailchimpRedirect()">Connect</button>
                <a class="button--close" @click="mailchimpModalOpen=false" v-t="'Cancel'"></a>
            </div>
        </modal>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Field from '@/components/Field.vue'
    import Modal from '@/components/Modal.vue'
    import SaveButton from '@/components/SaveButton.vue'

    export default {
        components: {
            Header,
            Field,
            Modal,
            SaveButton
        },
        data () {
            return {
                subscribers: null,
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                subscriberSettings: null,
                saving: false,
                errors: {},
                mailchimpModalOpen: false,
                mailchimpAudiences: [],
            }
        },
        methods: {
            mailchimpRedirect () {
                window.location = window.location.protocol +'//' + window.location.hostname.replace('app.', 'api.') + '/auth/mailchimp/'
            },
            disconnectMailchimp () {
                if(window.confirm('Are you sure you want to disconnect from Mailchimp? No data will be deleted in your Mailchimp account')){
                    this.saving = true
                    this.$http.post('/portfolio/subscribers/?disconnect', {}).then(data => {
                        this.subscriberSettings = data.data
                        this.saving = false
                        this.$store.dispatch('messages/success', "Mailchimp successfully disconnected")
                    }).catch(errors => {
                        this.saving = null
                        this.errors = errors.response.data
                    })
                }
            },
            save () {
                this.saving = true
                this.errors = {}
                this.$http.put('/portfolio/subscribers/', this.subscriberSettings).then(data => {
                    this.subscriberSettings = data.data
                    this.saving = false
                    this.$store.dispatch('messages/success', this.$t('messages.settings-saved'))
                }).catch(errors => {
                    this.saving = null
                    this.errors = errors.response.data
                })
            }
        },
        mounted () {
            this.$http.get('/portfolio/subscribers/').then(data => {
                this.subscriberSettings = data.data
                if (this.subscriberSettings.mailchimp_connected) {
                    this.$http.get('/mailchimp-lists/').then(data => {
                        this.mailchimpAudiences = data.data
                    })
                }
            })
            this.$http.get('/subscribers/').then(data => {
                this.subscribers = data.data
            })

            if(window.location.search==="?mailchimp_success"){
                this.$store.dispatch('messages/success', "Mailchimp successfully connected")
            }

        }
    }
</script>
